import { PropsWithChildren } from "react";

export default function SubHeader({ children }: PropsWithChildren<object>) {
  return (
    <div className="hidden w-full flex-row justify-between md:flex">
      {children}
    </div>
  );
}
